import React from 'react';

import type { IPricingTableComponentProps } from '../types';
import { SingleTable } from './SingleTable/SingleTable';
import { Tabs } from './Tabs/Tabs';

export const PricingTableWithTabs: React.FC<IPricingTableComponentProps> = ({
  bundles = [],
  categoriesWithFeatures = [],
  bundlesPricings = [],
  solutionTitle,
  ...tagFields
}) => {
  if (!bundles.length || !categoriesWithFeatures.length) return null;

  return (
    <Tabs bundles={bundles} {...tagFields}>
      {bundles.map((bundle, bundleIndex) => (
        <SingleTable
          bundle={bundle}
          categoriesWithFeatures={categoriesWithFeatures}
          pricings={bundlesPricings[bundleIndex]}
          key={bundle.id}
          solutionTitle={solutionTitle}
        />
      ))}
    </Tabs>
  );
};
